var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngineWash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105.484,
    height: 83.922,
    viewBox: "0 0 105.484 83.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 105.484,
    height: 83.922,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "engien_wash",
    "data-name": "engien wash",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M60.435,32.646c.025-.191.083-.378.125-.566a6.081,6.081,0,0,1-1.351.17,5.509,5.509,0,0,1-1.487-.225L60.4,33.777a5.891,5.891,0,0,1,.034-1.131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M37.721,55.421a6.044,6.044,0,1,0,6.049,6.045A6.043,6.043,0,0,0,37.721,55.421Z",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M76.187,22.875a18.573,18.573,0,0,1,4.01-.849l.071-.008-3.2-3.2-.011.1a18.893,18.893,0,0,1-.867,3.962"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M100.384,12.413a.909.909,0,0,1-.19-.126,1.13,1.13,0,0,0,.19.126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M82.614,29.3a18.573,18.573,0,0,1,4.01-.849l.071-.007-3.2-3.2-.011.1a18.83,18.83,0,0,1-.867,3.962"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M36.986,46.8a3.136,3.136,0,1,0-3.133,3.133A3.138,3.138,0,0,0,36.986,46.8Z",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M60.618,43.01a2.128,2.128,0,0,1-1.206,1.222l-.156.378a2.143,2.143,0,0,1-1.2,2.969l-.115.287a2.149,2.149,0,0,1-.6,2.727l.755.759v2.055h1.423V67.085H58.1V68.82L45.755,81.169H28.287L15.938,68.82V67.085H14.51V53.407h1.428V51.352l.755-.759a2.143,2.143,0,0,1-.591-2.727l-.118-.287a2.15,2.15,0,0,1-1.2-2.969l-.151-.378a2.154,2.154,0,0,1-1.211-1.222c-.016-.041-.023-.086-.037-.131a12.956,12.956,0,0,0-4.007,9.2V69.6c0,7.916,7.682,14.326,17.16,14.326H47.506c9.478,0,17.156-6.41,17.156-14.326V52.082a12.964,12.964,0,0,0-4-9.2c-.016.045-.025.09-.041.131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M44.836,56.2,37.064,45.77l-.036-.094a3.367,3.367,0,0,0-6.448,1.911l.024.115L29.288,58.834A8.832,8.832,0,1,0,46.55,61.467a8.818,8.818,0,0,0-1.382-4.75ZM30.715,46.8a3.136,3.136,0,1,1,3.138,3.133A3.14,3.14,0,0,1,30.715,46.8m7.006,20.712a6.044,6.044,0,1,1,6.049-6.041,6.039,6.039,0,0,1-6.049,6.041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M16.922,28.8l.406-3.88,3.982-1.554a.2.2,0,0,0,.05-.025.264.264,0,0,0,.1-.324l-1.562-4a.258.258,0,0,0-.144-.151.269.269,0,0,0-.2,0l-3.384,1.32a1.924,1.924,0,0,0-3.15,1.231l-2.054.8a.243.243,0,0,0-.05.029.266.266,0,0,0-.122.209L6.972,24.911a.282.282,0,0,0-.242.025.364.364,0,0,0-.041.028L5.11,26.507a1.939,1.939,0,0,0-1.616.217,1.919,1.919,0,0,0-.808,2.141L.082,31.4A.256.256,0,0,0,0,31.588a.27.27,0,0,0,.078.193l3,3.08a.268.268,0,0,0,.336.041c.016-.016.029-.025.041-.037l3.064-2.986,3.7,1.235Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M60.1,20.01a1.916,1.916,0,0,0-2.225.172l-3.388-1.321a.269.269,0,0,0-.2,0,.249.249,0,0,0-.135.152l-1.567,4a.269.269,0,0,0,.1.324.167.167,0,0,0,.046.024l1.936.756a7.262,7.262,0,0,1,1.355-1.871A9.719,9.719,0,0,1,60.1,20.01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M57.722,32.024a5.084,5.084,0,0,1-2.259-1.286,4.836,4.836,0,0,1-.405-.456l-1.917-1.254H50.758V9.958H52.9a.245.245,0,0,0,.209-.363L49.2,2.807a.225.225,0,0,0-.2-.115H41.166a.229.229,0,0,0-.206.119l-3.3,5.716H36.383l-3.3-5.72a.239.239,0,0,0-.2-.115H25.048a.232.232,0,0,0-.2.119L20.926,9.6a.228.228,0,0,0,0,.229.24.24,0,0,0,.213.134H23.25v19.07H20.9L12.21,34.713l.086.213-.159.271a.835.835,0,0,0-.046.693.82.82,0,0,0,.525.488l.3.09.7,1.731-.18.291a.822.822,0,0,0-.07.726.83.83,0,0,0,.566.5l.324.077.689,1.694-.2.295a.829.829,0,0,0-.09.759.815.815,0,0,0,.6.5l.344.073.677,1.657-.23.3a.793.793,0,0,0-.106.783.81.81,0,0,0,.631.513l.369.057.665,1.633-.25.3a.812.812,0,0,0-.136.816.8.8,0,0,0,.673.517l.394.045.311.771-.3.345L17.259,51.9v2.826H15.836V65.76h1.423v2.51L28.837,79.849H45.205L56.779,68.27V65.76h1.428V54.728H56.779V51.9l-1.353-1.358.316-.767.4-.082a.816.816,0,0,0,.539-1.333l-.25-.3.66-1.633.372-.057a.809.809,0,0,0,.632-.513.782.782,0,0,0-.111-.783l-.22-.3.668-1.657.348-.073a.812.812,0,0,0,.508-1.26l-.2-.295.681-1.694.327-.077a.817.817,0,0,0,.562-.5.79.79,0,0,0-.069-.722l-.176-.291.7-1.731.162-.048a5.281,5.281,0,0,1-.884-2.644Zm-20,39.593A10.159,10.159,0,0,1,28.009,58.5l1.255-10.725a4.885,4.885,0,0,1-.1-.981,4.689,4.689,0,0,1,9.077-1.657l8.45,11.329-.091.069a10.149,10.149,0,0,1-8.875,15.081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M69.357,25.529a3.73,3.73,0,0,0,2.372-.953c.047-.04.2-.174.255-.234,1.492-1.491,1.963-4.619,2.088-5.758-1.146.116-4.292.571-5.784,2.062-1.327,1.327-1.575,3.233-.556,4.251a2.253,2.253,0,0,0,1.625.632m-1.007-3.8a.368.368,0,0,1,.52.52,1.031,1.031,0,0,0,0,1.458.369.369,0,0,1,0,.522.364.364,0,0,1-.26.107.37.37,0,0,1-.261-.107,1.77,1.77,0,0,1,0-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M74.158,31.324a2.253,2.253,0,0,0,1.625.632A3.735,3.735,0,0,0,78.156,31c.046-.04.194-.174.255-.234,1.491-1.491,1.962-4.619,2.088-5.758-1.147.116-4.293.571-5.784,2.062-1.327,1.327-1.575,3.232-.557,4.251m.618-3.168a.368.368,0,1,1,.52.52,1.031,1.031,0,0,0,0,1.458.369.369,0,0,1-.522.522,1.77,1.77,0,0,1,0-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M80.585,37.75a2.249,2.249,0,0,0,1.625.633,3.729,3.729,0,0,0,2.373-.954c.047-.039.195-.173.255-.234,1.491-1.491,1.962-4.619,2.088-5.758-1.146.116-4.293.571-5.784,2.062-1.327,1.328-1.575,3.233-.557,4.251m.878-3.275a.368.368,0,0,1,.26.628,1.031,1.031,0,0,0,0,1.458.368.368,0,0,1-.261.629.365.365,0,0,1-.26-.108,1.769,1.769,0,0,1,0-2.5.367.367,0,0,1,.26-.108"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M58.14,24.367c-1.327,1.327-1.575,3.233-.557,4.251a2.253,2.253,0,0,0,1.625.632,3.733,3.733,0,0,0,2.373-.953c.047-.039.195-.174.255-.234,1.491-1.491,1.962-4.619,2.088-5.758-1.146.116-4.293.571-5.784,2.062m.582,3.583a.368.368,0,0,1-.521,0,1.769,1.769,0,0,1,0-2.5.367.367,0,1,1,.52.519,1.033,1.033,0,0,0,0,1.459.37.37,0,0,1,0,.521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M64.567,30.793c-1.327,1.327-1.575,3.233-.557,4.251a2.253,2.253,0,0,0,1.625.632,3.733,3.733,0,0,0,2.373-.953c.047-.04.195-.174.255-.234,1.491-1.491,1.962-4.619,2.088-5.758-1.146.116-4.293.571-5.784,2.062m.582,3.583a.368.368,0,0,1-.521,0,1.77,1.77,0,0,1,0-2.5.368.368,0,1,1,.52.52,1.032,1.032,0,0,0,0,1.459.37.37,0,0,1,0,.521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M70.994,37.22c-1.327,1.327-1.575,3.233-.557,4.251a2.253,2.253,0,0,0,1.625.633,3.727,3.727,0,0,0,2.373-.954c.047-.039.195-.174.255-.234,1.491-1.491,1.962-4.619,2.088-5.758-1.146.116-4.293.571-5.784,2.062m.582,3.583a.368.368,0,0,1-.521,0,1.769,1.769,0,0,1,0-2.5.368.368,0,1,1,.52.52,1.032,1.032,0,0,0,0,1.458.37.37,0,0,1,0,.521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M76.864,47.9a2.253,2.253,0,0,0,1.625.633,3.729,3.729,0,0,0,2.373-.954c.047-.039.195-.173.255-.234,1.491-1.491,1.962-4.619,2.088-5.758-1.146.116-4.293.571-5.784,2.062-1.327,1.328-1.575,3.233-.557,4.251m.878-3.275a.367.367,0,0,1,.26.628,1.032,1.032,0,0,0,0,1.458.369.369,0,0,1-.261.629.365.365,0,0,1-.26-.108,1.769,1.769,0,0,1,0-2.5.367.367,0,0,1,.26-.108"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M97.256,18.336l-2.219-2.219,3.471-3.471-2.066-2.321-2.758-3.1-.517-.581-3.8,3.8L87.148,8.228l-6.484-.155,7.347,8.947L76.15,7.281a1.505,1.505,0,0,1-.541-1.327L72.524,2.869l-5.7,5.7,7.02,7.02,3.224,3.224,3.2,3.2,3.224,3.224,3.2,3.2,3.224,3.224,6.993,6.993,5.7-5.7-5.132-5.133Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M101.07,10.084l4.414-4.414L99.814,0,95.729,4.085l5.3,5.947.046.052"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M100.193,12.287Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineWash);
export default __webpack_public_path__ + "static/media/engineWash.4dd198d1ec85e644de8424e8924f352a.svg";
export { ForwardRef as ReactComponent };